<template>
  <div class="container mt-4">
    <TopNav :showOpenMainNav="true" :icon="['far', 'users']" />
    <h2 class="mt-4">
      {{ $t(`REPORTS.LABEL.${$route.params.group.toUpperCase()}`) }}
    </h2>
    <div v-if="!isLoading">
      <div
        v-if="filteredReportsByGroup && filteredReportsByGroup.length"
        class="my-5"
      >
        <div class="mb-3">
          <div class="">
            <HMSearch v-model="search" />
          </div>
        </div>
        <hr class="my-2" />
        <div v-for="report in filteredReports" :key="report.question_id">
          <router-link
            :to="{ name: 'report-detail', params: { report_id: report.id } }"
            class="c-charcoal"
          >
            <font-awesome-icon
              :icon="
                report.report_type === 'graph'
                  ? ['far', 'chart-bar']
                  : ['far', 'file-spreadsheet']
              "
              class="text-primary mr-1 fa-fw"
            />
            {{ report.title }}
          </router-link>
          <hr class="my-2" />
        </div>
      </div>
      <div v-if="!(filteredReportsByGroup && filteredReportsByGroup.length)">
        <HMEmpty
          :title="$t('REPORTS.TEXT.NO_REPORTS_YET')"
          :description="
            $tc('REPORTS.TEXT.CHECK_BACK_LATER', $route.params.group, {
              x: $route.params.group,
            })
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/web/components/navigation/TopNav.vue';
import { errorToMessage } from '@/core/utils/errors';

export default {
  name: 'ReportListByGroup',
  components: {
    TopNav,
  },
  data() {
    return {
      isLoading: true,
      reports: null,
      search: null,
    };
  },
  computed: {
    filteredReportsByGroup() {
      if (!this.reports) {
        return;
      }
      return this.reports.filter(
        report => report.group == this.$route.params.group
      );
    },
    filteredReports() {
      if (!(this.search && this.search.trim())) {
        return this.filteredReportsByGroup;
      }
      return this.filteredReportsByGroup.filter(
        report =>
          report.title &&
          report.title.toLowerCase().indexOf(this.search.trim()) > -1
      );
    },
  },
  async mounted() {
    try {
      this.reports = await this.$store.dispatch('report/getMetabaseReports');
      this.isLoading = false;
    } catch (error) {
      this.$notify({
        group: 'app',
        type: 'error',
        title: 'Failed to load reports',
        text: errorToMessage(error.response, `Request failed: ${error}`),
        duration: -1, // stay ON
      });
    }
  },
};
</script>
<style lang="scss" scoped></style>
